import { render, staticRenderFns } from "./MonthlyCostItem.vue?vue&type=template&id=8cd868ce&scoped=true&"
import script from "./MonthlyCostItem.vue?vue&type=script&lang=js&"
export * from "./MonthlyCostItem.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyCostItem.vue?vue&type=style&index=0&id=8cd868ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd868ce",
  null
  
)

export default component.exports